// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --font-family: "Urbanist", Sans-serif;
    --mainColor: #273450;
    --bgColor: #F1F5F6;
}

.loading {
    margin-top: 5px;
    margin-bottom: 10px;
    margin-left: 8px;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    border-radius: 50px;
}

.loading__dot {
    animation: dot ease-in-out 1s infinite;
    background-color: grey;
    display: inline-block;
    height: 7px;
    margin: 4px;
    width: 7px;
    border-radius: 50px;
}

.loading__dot:nth-of-type(2) {
    animation-delay: 0.2s;
}

.loading__dot:nth-of-type(3) {
    animation-delay: 0.3s;
}

@keyframes dot {
    0% {
        background-color: grey;
        transform: scale(1);
    }

    50% {
        background-color: gray;
        transform: scale(1.3);
    }

    100% {
        background-color: grey;
        transform: scale(1);
    }
}


.rotate-icon {
    transition: transform 0.2s;
}

.open .rotate-icon {
    transform: rotate(45deg);
}

.custom-speed-dial {
    position: relative;
}

.speed-dial-button {
    width: 58px;
    height: 58px;
    background-color: var(--mainColor);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.3s ease-in-out;
}

.speed-dial-button.open {
    transform: rotate(92deg);
}

.chat-widget {
    position: absolute;
    top: 70px;
    right: 20px;
    width: 300px;
    height: 400px;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
}


.docs_custom_chat_main_div {
    position: fixed;
    height: 100%;
    width: 25%;
    /* z-index: 9999999; */
}

.docs_custom_chat_open_btn {
    position: fixed;
    right: 15px;
    bottom: 0;
    margin: 0 20px 20px 0;
    cursor: pointer;
    z-index: 999999 !important;
}

.docs_custom_chat_header_div {
    display: flex;
    align-items: center;
    padding: 12px 0px;
    background: white;
    height: 52px;
    width: 100%;
    background-color: var(--mainColor);
}

.docs_custom_chat_header_inner-img{
    width: 38px;
}
.docs_custom_chat_header_inner {
    display: flex;
    margin-left: 23px;
    align-items: center;
    justify-content: center;
    color: white;
}

.docs_custom_chat_header_inner>p {
    padding-left: 7px;
    font-size: 15px;
    color: white !important;
    font-weight: bold;
    margin-bottom: 0;
    font-family: var(--font-family);
}

.docs_custom_chat_bot_close_icon {
    font-size: 24px;
    position: absolute;
    right: 10px;
    color: black;
}

.docs_custom_chat_body_div {
    height: calc(100vh - 235px);
    overflow-y: auto;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    /* background-color: var(--bgColor); */
}

.docs_custom_chat_user_prompt {
    float: right;
    word-wrap: break-word;
    color: var(--mainColor);
    background-color: white !important;
    border-radius: 1px;
    max-width: 75%;
    padding: 0px 15px 0px 15px;
    margin: 10px 10px 10px auto;
    text-align: left;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    white-space: pre-wrap;
    font-family: inherit;

}

.docs_custom_chat_user_prompt_para {
    margin: 10px 10px 10px 0px;
    font-family: inherit;
    font-weight: 400;
}

.docs_custom_message_prompt_para {
    margin: 5px 5px 5px -9px;
    font-family: inherit;
    font-weight: 400;
}

.docs_custom_chat_bot_prompt {
    border-radius: 1px;
    background-color: white;
    max-width: 75%;
    padding: 0px 14px 0px;
    text-align: left;
    word-wrap: break-word;
    display: flex;
    margin: 10px auto 10px 10px;
    white-space: pre-wrap;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.docs_custom_chat_bot_avatar {
    border-radius: 50px;
    width: 40px;
    height: 40px;
    margin-left: 45px;
    margin-top: 12px;
}

.rotate-45-degrees {
    transform: rotate(-30deg);
}

.docs_custom_chat_loader {
    margin: 15px auto;
    width: 33px;
    height: 7px;
    background: rebeccapurple;
    background-size: calc(100% / 3) 100%;
    background-repeat: no-repeat;
    animation: dots-zcf63l 1s infinite linear;
}

.docs_custom_chat_bot_icon {
    color: #fff;
    font-size: 30px !important;
    cursor: pointer;
    margin-right: 6px;
}

.docs_custom_chat_footer_div {
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    /* border: none !important; */
    padding: 4px;
    bottom: 0;
    right: 2%;
}

.docs_custom_chat_input:focus {
    outline: none;
    border: none !important;
}

.docs_custom_chat_input::placeholder {
    font-size: 17px !important;
    color: rgb(104, 102, 102) !important;
    border: none !important;
    font-family: var(--font-family);
}

.docs_custom_chat_input {
    background-color:#A3A3A326;
    color: black;
    border-radius: 8px;
    border: none !important;
    padding: 8px 5px;
    height: 54px;
    width: 100% !important;
    font-size: 17px;
    margin-right: 10px;
    max-width: 100% !important;
}

.attach_icon {
    position: fixed;
    right: 44.5%;
    font-size: 25px;
}

.chat-icons {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    font-size: 22px;
    color: #BFBFBF;
    margin-bottom: 15px;
    align-self: flex-end;
}

.chat-icons svg {
    margin: 0 5px;
    cursor: pointer;
}

.chat-row-icons {
    padding-top: 3px !important;
}

.bot_animation {
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    margin: 0px auto;
    left: 0px;
    right: 0px;
    top: 35%;
    align-items: center;
    z-index: 99999;
}

.bot_animation span {
    margin-top: 50px;
    font-weight: lighter;
    color: #4E4E4E;
}

.send_icon {
    background-color: #4273B8;
    border-radius: 8px;
    padding: 8px 5px;
    width: 54px;
    height: 53px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.ant-modal {
    border-radius: 8px !important;
}

.modal-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}


.ant-modal-content {
    border-radius: 8px !important;
}

.ant-modal-header {
    border-top-right-radius: 8px !important;
    border-top-left-radius: 8px !important;
}

.support  .ant-btn {
    background: #fff !important;
    padding: 6px 12px !important;
    height: auto !important;
    border-radius: 6px !important;
    border: 1px solid rgba(66, 115, 184, 1);
    color: rgba(66, 115, 184, 1) !important;
}

.submit .ant-btn {
    background: rgba(66, 115, 184, 1) !important;
    padding: 6px 12px !important;
    height: auto !important;
    border-radius: 6px !important;
    color: white !important;
}

/* @media only screen and (max-width: 800px) {
    .docs_custom_chat_main_div {
        position: fixed;
        margin: 0px;
        height: 468px;
        right: 15;
        bottom: 60px;
    }

    .docs_custom_chat_header_div {
        border-radius: 0px;
    }

    .docs_custom_chat_footer_div {
        margin: 0px;
        border-radius: 0px;
    }
}
@media only screen and (max-width: 1025px) {
 
    .docs_custom_chat_main_div {
        width: 33%;
        right: 0;
    }

    .docs_custom_chat_footer_div {
        width: 33%;
    }
}
@media only screen and (max-width: 470px) {
    .docs_custom_chat_bot_avatar {
        display: none;
    }

    .docs_custom_chat_main_div {
        width: 346px;
        right: 0;
    }

    .docs_custom_chat_footer_div {
        width: 346px;
    }
} */`, "",{"version":3,"sources":["webpack://./src/Screens/Chat/ChatWidget.styles.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;;AAGA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,uBAAuB;IACvB,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;IAChB,4CAA4C;IAC5C,qBAAqB;IACrB,oBAAoB;;AAExB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,2BAA2B;IAC3B,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,oCAAoC;IACpC,4BAA4B;IAC5B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,SAAS;IACT,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,uBAAuB;IACvB,6BAA6B;IAC7B,uCAAuC;IACvC,uCAAuC;AAC3C;;AAEA;IACI,4CAA4C;IAC5C,4BAA4B;IAC5B,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0CG","sourcesContent":[":root {\n    --font-family: \"Urbanist\", Sans-serif;\n    --mainColor: #273450;\n    --bgColor: #F1F5F6;\n}\n\n.loading {\n    margin-top: 5px;\n    margin-bottom: 10px;\n    margin-left: 8px;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    border-radius: 50px;\n}\n\n.loading__dot {\n    animation: dot ease-in-out 1s infinite;\n    background-color: grey;\n    display: inline-block;\n    height: 7px;\n    margin: 4px;\n    width: 7px;\n    border-radius: 50px;\n}\n\n.loading__dot:nth-of-type(2) {\n    animation-delay: 0.2s;\n}\n\n.loading__dot:nth-of-type(3) {\n    animation-delay: 0.3s;\n}\n\n@keyframes dot {\n    0% {\n        background-color: grey;\n        transform: scale(1);\n    }\n\n    50% {\n        background-color: gray;\n        transform: scale(1.3);\n    }\n\n    100% {\n        background-color: grey;\n        transform: scale(1);\n    }\n}\n\n\n.rotate-icon {\n    transition: transform 0.2s;\n}\n\n.open .rotate-icon {\n    transform: rotate(45deg);\n}\n\n.custom-speed-dial {\n    position: relative;\n}\n\n.speed-dial-button {\n    width: 58px;\n    height: 58px;\n    background-color: var(--mainColor);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: transform 0.3s ease-in-out;\n}\n\n.speed-dial-button.open {\n    transform: rotate(92deg);\n}\n\n.chat-widget {\n    position: absolute;\n    top: 70px;\n    right: 20px;\n    width: 300px;\n    height: 400px;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n}\n\n\n.docs_custom_chat_main_div {\n    position: fixed;\n    height: 100%;\n    width: 25%;\n    /* z-index: 9999999; */\n}\n\n.docs_custom_chat_open_btn {\n    position: fixed;\n    right: 15px;\n    bottom: 0;\n    margin: 0 20px 20px 0;\n    cursor: pointer;\n    z-index: 999999 !important;\n}\n\n.docs_custom_chat_header_div {\n    display: flex;\n    align-items: center;\n    padding: 12px 0px;\n    background: white;\n    height: 52px;\n    width: 100%;\n    background-color: var(--mainColor);\n}\n\n.docs_custom_chat_header_inner-img{\n    width: 38px;\n}\n.docs_custom_chat_header_inner {\n    display: flex;\n    margin-left: 23px;\n    align-items: center;\n    justify-content: center;\n    color: white;\n}\n\n.docs_custom_chat_header_inner>p {\n    padding-left: 7px;\n    font-size: 15px;\n    color: white !important;\n    font-weight: bold;\n    margin-bottom: 0;\n    font-family: var(--font-family);\n}\n\n.docs_custom_chat_bot_close_icon {\n    font-size: 24px;\n    position: absolute;\n    right: 10px;\n    color: black;\n}\n\n.docs_custom_chat_body_div {\n    height: calc(100vh - 235px);\n    overflow-y: auto;\n    padding-top: 10px;\n    display: flex;\n    flex-direction: column;\n    /* background-color: var(--bgColor); */\n}\n\n.docs_custom_chat_user_prompt {\n    float: right;\n    word-wrap: break-word;\n    color: var(--mainColor);\n    background-color: white !important;\n    border-radius: 1px;\n    max-width: 75%;\n    padding: 0px 15px 0px 15px;\n    margin: 10px 10px 10px auto;\n    text-align: left;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n    white-space: pre-wrap;\n    font-family: inherit;\n\n}\n\n.docs_custom_chat_user_prompt_para {\n    margin: 10px 10px 10px 0px;\n    font-family: inherit;\n    font-weight: 400;\n}\n\n.docs_custom_message_prompt_para {\n    margin: 5px 5px 5px -9px;\n    font-family: inherit;\n    font-weight: 400;\n}\n\n.docs_custom_chat_bot_prompt {\n    border-radius: 1px;\n    background-color: white;\n    max-width: 75%;\n    padding: 0px 14px 0px;\n    text-align: left;\n    word-wrap: break-word;\n    display: flex;\n    margin: 10px auto 10px 10px;\n    white-space: pre-wrap;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n\n.docs_custom_chat_bot_avatar {\n    border-radius: 50px;\n    width: 40px;\n    height: 40px;\n    margin-left: 45px;\n    margin-top: 12px;\n}\n\n.rotate-45-degrees {\n    transform: rotate(-30deg);\n}\n\n.docs_custom_chat_loader {\n    margin: 15px auto;\n    width: 33px;\n    height: 7px;\n    background: rebeccapurple;\n    background-size: calc(100% / 3) 100%;\n    background-repeat: no-repeat;\n    animation: dots-zcf63l 1s infinite linear;\n}\n\n.docs_custom_chat_bot_icon {\n    color: #fff;\n    font-size: 30px !important;\n    cursor: pointer;\n    margin-right: 6px;\n}\n\n.docs_custom_chat_footer_div {\n    margin-bottom: 10px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 60px;\n    /* border: none !important; */\n    padding: 4px;\n    bottom: 0;\n    right: 2%;\n}\n\n.docs_custom_chat_input:focus {\n    outline: none;\n    border: none !important;\n}\n\n.docs_custom_chat_input::placeholder {\n    font-size: 17px !important;\n    color: rgb(104, 102, 102) !important;\n    border: none !important;\n    font-family: var(--font-family);\n}\n\n.docs_custom_chat_input {\n    background-color:#A3A3A326;\n    color: black;\n    border-radius: 8px;\n    border: none !important;\n    padding: 8px 5px;\n    height: 54px;\n    width: 100% !important;\n    font-size: 17px;\n    margin-right: 10px;\n    max-width: 100% !important;\n}\n\n.attach_icon {\n    position: fixed;\n    right: 44.5%;\n    font-size: 25px;\n}\n\n.chat-icons {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n    font-size: 22px;\n    color: #BFBFBF;\n    margin-bottom: 15px;\n    align-self: flex-end;\n}\n\n.chat-icons svg {\n    margin: 0 5px;\n    cursor: pointer;\n}\n\n.chat-row-icons {\n    padding-top: 3px !important;\n}\n\n.bot_animation {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    position: absolute;\n    margin: 0px auto;\n    left: 0px;\n    right: 0px;\n    top: 35%;\n    align-items: center;\n    z-index: 99999;\n}\n\n.bot_animation span {\n    margin-top: 50px;\n    font-weight: lighter;\n    color: #4E4E4E;\n}\n\n.send_icon {\n    background-color: #4273B8;\n    border-radius: 8px;\n    padding: 8px 5px;\n    width: 54px;\n    height: 53px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.ant-modal {\n    border-radius: 8px !important;\n}\n\n.modal-buttons {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 30px;\n}\n\n\n.ant-modal-content {\n    border-radius: 8px !important;\n}\n\n.ant-modal-header {\n    border-top-right-radius: 8px !important;\n    border-top-left-radius: 8px !important;\n}\n\n.support  .ant-btn {\n    background: #fff !important;\n    padding: 6px 12px !important;\n    height: auto !important;\n    border-radius: 6px !important;\n    border: 1px solid rgba(66, 115, 184, 1);\n    color: rgba(66, 115, 184, 1) !important;\n}\n\n.submit .ant-btn {\n    background: rgba(66, 115, 184, 1) !important;\n    padding: 6px 12px !important;\n    height: auto !important;\n    border-radius: 6px !important;\n    color: white !important;\n}\n\n/* @media only screen and (max-width: 800px) {\n    .docs_custom_chat_main_div {\n        position: fixed;\n        margin: 0px;\n        height: 468px;\n        right: 15;\n        bottom: 60px;\n    }\n\n    .docs_custom_chat_header_div {\n        border-radius: 0px;\n    }\n\n    .docs_custom_chat_footer_div {\n        margin: 0px;\n        border-radius: 0px;\n    }\n}\n@media only screen and (max-width: 1025px) {\n \n    .docs_custom_chat_main_div {\n        width: 33%;\n        right: 0;\n    }\n\n    .docs_custom_chat_footer_div {\n        width: 33%;\n    }\n}\n@media only screen and (max-width: 470px) {\n    .docs_custom_chat_bot_avatar {\n        display: none;\n    }\n\n    .docs_custom_chat_main_div {\n        width: 346px;\n        right: 0;\n    }\n\n    .docs_custom_chat_footer_div {\n        width: 346px;\n    }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
